import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import React from "react";
import { IoArrowBackCircleOutline, IoArrowForwardCircleOutline } from "react-icons/io5";
import image1 from "../../../assets/frontendassets/websiteimages/circle.png";
import true1 from "../../../assets/frontendassets/websiteimages/true.png";
import "./GetStartedWithUs.css";

const GetStartedWithUs = () => {
  const services = [
    {
      title: "Global Reach",
      subtitle: "Process",
      description:
        "Reach both B2B and B2C audiences across the globe, breaking geographical borders.",
    },
    {
      title: "Industry Trends",
      subtitle: "and Insights",
      description:
        "Stay ahead of the curve with the latest industry trends and market insights.",
    },
    {
      title: "Marketing Tools",
      subtitle: "",
      description:
        "Access powerful marketing tools to promote your business effectively.",
    },
    {
      title: "Business Growth",
      subtitle: "",
      description:
        "Connect with new clients, suppliers, and partners to expand your business horizons.",
    },
    {
      title: "Verified Listing",
      subtitle: "",
      description:
        "Display the N4S Trust Seal & N4S verification to reassure customers of your authenticity.",
    },
    {
      title: "Free Business Listing",
      subtitle: "",
      description:
        "List your business for free and get noticed by millions of potential customers.",
    },
  ];

  return (
    <div>
      {/* Header Section */}
      <div className="flex items-center pt-[25px]  bg-[#FFF8EC] xs:p-3 xxs:p-2 md:pl-12 md:pr-12 pl-12">
        <hr className="line w-36 bg-[#FFF8EC]" />
        <div className="text-black ml-4 xxs:text-[16px] text-[20px] bg-[#FFF8EC] ">
          WHAT WE OFFER
        </div>
      </div>
      <p className="description text-[20px] xs:p-3 xxs:p-3 md:pl-12 md:pr-12 xs:text-3xl bg-[#FFF8EC] md:text-3xl lg:text-[30px]">
        At India's No.1 B2B and B2C Marketplace,<br /> we provide an array of
        services designed <br /> to help your business thrive:
      </p>

      {/* Swiper Section */}
      <div className="get-started-swiper-wrapper bg-[#FFF8EC] relative">
        {/* Custom Navigation Buttons */}
        <button
          className=" custom-prev absolute left-2 top-1/2 transform -translate-y-1/2 z-10"
          aria-label="Previous Slide"
        >
          <IoArrowBackCircleOutline size={40} className="text-[#F9B138]" />
        </button>
        <button
          className=" custom-next absolute right-2 top-1/2 transform -translate-y-1/2 z-10"
          aria-label="Next Slide"
        >
          <IoArrowForwardCircleOutline size={40} className="text-[#F9B138]" />
        </button>

        <Swiper
          className="get-started-swiper"
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            nextEl : ".custom-next",
            prevEl : ".custom-prev",
          }}
          
          // loop={true}
          // autoplay={{
          //   delay: 5000,
          //   disableOnInteraction: false,
          // }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div
                className="slide-content relative w-[95%] p-6 rounded-lg flex flex-col items-center justify-center"
                style={{
                  height: "350px",
                  backgroundImage: `url(${image1})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div
                  className="decorative-image absolute w-[5rem] h-[8rem] m-8 
                    sm:top-[11rem] sm:right-6 sm:bottom-auto 
                    bottom-[54px] xxs:right-[-40px] xxs:bottom-[30px] right-[-32px] xs:bottom-0 sm:bottom-[-20px] sm:right-[-1.5rem] lg:right-0"
                  style={{
                    backgroundImage: `url(${true1})`,
                    backgroundSize: "contain",
                    backgroundPosition: "bottom right",
                    backgroundRepeat: "no-repeat",
                    zIndex: 1,
                  }}
                ></div>
                <div className="text-content relative flex flex-col gap-2 items-center justify-center text-center h-full w-full z-10">
                  <p className="service-title text-[20px] sm:text-2xl text-[#118601] font-semibold">
                    {service.title} <br />
                    {service.subtitle && (
                      <span className="service-subtitle text-[16px]">
                        {service.subtitle}
                      </span>
                    )}
                  </p>
                  <p className="service-description text-black text-[14px] mt-2 px-0 sm:px-16 sm:flex sm:flex-row sm:space-x-4 w-[9rem] sm:w-[15rem]">
                    {service.description}
                  </p>
                  <button className="cta-button  text-black bg-[#F9B138] text-[12px] h-8 w-24 mt-3 rounded-lg hover:bg-[#d8970e]">
                    Start Now
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default GetStartedWithUs;
